// Front/src/components/ProtectedRoute.js

import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuthContext();

  if (loading) {
    // Show nothing or a loading spinner until the auth status is ready
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;

